import WhsManagementGridActions from 'components/WhsManagement/whsManagementGridActions.js';
import whsManagementColumnDefs from 'components/WhsManagement/whsManagementColumnDefs.js';
import {
  GET_WHS_REQUEST, GET_WHS_SUCCESS, GET_WHS_FAILURE, NEW_WHS_GRID_CRITERIA,
  GET_LINKED_ACCOUNTS_REQUEST, GET_LINKED_ACCOUNTS_SUCCESS, GET_LINKED_ACCOUNTS_FAILURE,
  CLOSE_LINKED_ACCOUNTS_MODAL
} from 'actions';

const initialState = {
  loading: true,
  data: [],
  error: '',
  actions: WhsManagementGridActions,
  gridCriteria: {
    columnDefs: whsManagementColumnDefs(),
    pageIndex: 0,
    sortBy: [],
    filters: [],
    pageCount: 0,
    pageSize: 50,
    itemCount: 0,
    selectedItems: [],
    selectedItem: null,
    activeTab: 0,
    totalLimit: 50000
  },
  linkedAccountsModalShown: false,
  isGettingLinkedAccounts: false,
  linkedAccounts: [],
};

// eslint-disable-next-line default-param-last
function withholdingStatement(state = initialState, action) {
  switch (action.type) {
    case NEW_WHS_GRID_CRITERIA:
      return {
        ...state,
        gridCriteria: action.gridCriteria
      };
    case GET_WHS_REQUEST:
      return {
        ...state,
        loading: action.loading
      };
    case GET_WHS_SUCCESS:
      return {
        ...state,
        loading: action.loading,
        data: action.data.results,
        error: action.error,
        gridCriteria: {
          ...state.gridCriteria,
          itemCount: action.data.totalCount,
          pageCount: Math.ceil(action.data.totalCount / state.gridCriteria.pageSize)
        }
      };
    case GET_WHS_FAILURE:
      return {
        ...state,
        loading: action.loading,
        data: [],
        error: action.error
      };
    case GET_LINKED_ACCOUNTS_REQUEST:
    case GET_LINKED_ACCOUNTS_SUCCESS:
    case GET_LINKED_ACCOUNTS_FAILURE:
      return {
        ...state,
        linkedAccountsModalShown: true,
        isGettingLinkedAccounts: action.isGettingLinkedAccounts,
        linkedAccounts: action.linkedAccounts,
        error: action.error
      };
    case CLOSE_LINKED_ACCOUNTS_MODAL:
      return {
        ...state,
        linkedAccountsModalShown: false,
        isGettingLinkedAccounts: false,
        linkedAccounts: [],
        error: ''
      };
    default:
      return state;
  }
}

export default withholdingStatement;
